import { TranslocoService } from "@ngneat/transloco";

export enum RegistrationRequestStatus {
  /** Не определено */
  Unspecified = 0,

  /** Ожидает подтверждения Контролером */
  WaitForApproveController = 1,

  /** Подтверждена Контролером */
  ApprovedByController = 2,

  /** Отклонена Контролером */
  DeclinedByController = 3,

  /** Ожидает подтверждения Владельцем ЛК организации */
  WaitForApproveChief = 4,

  /** Отклонена Владельцем ЛК организации */
  DeclinedByChief = 5,

  /** Отправлена в ИС (ожидание ответа) */
  SentToClient = 6,

  /** Подтверждена Владельцем ЛК организации */
   ApprovedByChief = 7
}

export const RegistrationRequestStatusTranslationKeys: Record<RegistrationRequestStatus, string> = {
  [RegistrationRequestStatus.Unspecified]: 'registrationStrangers.statuses.unspecified',
  [RegistrationRequestStatus.WaitForApproveController]: 'registrationStrangers.statuses.waitForApproveController',
  [RegistrationRequestStatus.ApprovedByController]: 'registrationStrangers.statuses.approvedByController',
  [RegistrationRequestStatus.DeclinedByController]: 'registrationStrangers.statuses.declinedByController',
  [RegistrationRequestStatus.WaitForApproveChief]: 'registrationStrangers.statuses.waitForApproveChief',
  [RegistrationRequestStatus.DeclinedByChief]: 'registrationStrangers.statuses.declinedByChief',
  [RegistrationRequestStatus.SentToClient]: 'registrationStrangers.statuses.sentToClient',
  [RegistrationRequestStatus.ApprovedByChief]: 'registrationStrangers.statuses.approvedByChief',
};

export function getRequestStatusName(
  status: RegistrationRequestStatus,
  translocoService: TranslocoService
): string {
  const key = RegistrationRequestStatusTranslationKeys[status];
  return key ? translocoService.translate(key) : '-';
}

export function getRequestStatusIconName(status: RegistrationRequestStatus): string {
  switch (status) {
    case RegistrationRequestStatus.WaitForApproveController:
    case RegistrationRequestStatus.WaitForApproveChief:
      return 'icon-registration-request-waiting-active';
    case RegistrationRequestStatus.ApprovedByController:
    case RegistrationRequestStatus.ApprovedByChief:
      return 'icon-registration-request-approved-active';
    case RegistrationRequestStatus.DeclinedByController:
    case RegistrationRequestStatus.DeclinedByChief:
      return 'icon-registration-request-decline-active';
    case RegistrationRequestStatus.SentToClient:
      return 'icon-registration-request-waiting-yellow';
    default:
      return '-';
  }
}
